export const confirmModalStyle = {
    width: 500,
    height: "auto",
    pivotY: 0.1,
    name: "confirm-modal",
};